import { Navigate, Outlet, useLocation } from "react-router";
import { AppSkeleton } from "../app/ConferisApp.js";
import { useSession } from "./SessionProvider.js";

export function RequireSession() {
  const { ready, user } = useSession();
  const location = useLocation();
  if (!ready) return <AppSkeleton />;
  if (!user) {
    const next = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <Outlet />;
}
